import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { IonicModule } from '@ionic/angular';
import { InternetComponent } from '../../components/internet/internet.component';
import { SanitizePipe } from '../../../pipes/sanitize.pipe';
import { RestriccionLiturgiaComponent } from '../../components/restriccion-liturgia/restriccion-sin-data.component';



@NgModule({
  declarations: [InternetComponent,SanitizePipe ],
  imports: [
    CommonModule,
    IonicModule,
    PdfViewerModule,
    MatStepperModule,
    MatInputModule,
    MatButtonModule,
    MatProgressBarModule,
    MatDialogModule,

    MatSelectModule,
    MatRadioModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatToolbarModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
  ],
  exports:[InternetComponent,SanitizePipe]
})
export class ShareModule { }
